export const slides = [
  {
    id: 1,
    imageUrl: '/images/carousel/tam-coc.jpeg',
    title: 'טאם קוק',
    description: 'טאם קוק',
  },
  {
    id: 2,
    imageUrl: '/images/carousel/cat-cat.jpeg',
    title: 'קאט קאט',
    description: 'קאט קאט',
  },
  {
    id: 3,
    imageUrl: '/images/carousel/ba-na-hills.jpeg',
    title: 'בא נה הילס',
    description: 'בא נה הילס',
  },
  {
    id: 4,
    imageUrl: '/images/carousel/hoi-an.jpeg',
    title: 'הוי אן',
    description: 'הוי אן',
  },
  {
    id: 5,
    imageUrl: '/images/carousel/kampot.jpeg',
    title: 'קמפוט',
    description: 'קמפוט',
  },
  {
    id: 6,
    imageUrl: '/images/carousel/koh-phi-phi.jpeg',
    title: 'קו פי פי',
    description: 'קו פי פי',
  },
  {
    id: 7,
    imageUrl: '/images/carousel/bangkok.jpeg',
    title: 'בנגקוק',
    description: 'בנגקוק',
  },
];
